import { lazy } from 'react';

export const CalculationWorkVolume = lazy(() =>
    import('./CalculationWorkVolume').then((module) => ({ default: module.CalculationWorkVolume })),
);
